<template>
  <div class="pay">
    <div class="topHeader clear">
      <header class="mint-header is-fixed"
              style="background-color: rgb(57, 60, 65);">
        <div class="mint-header-button is-left"
             @click="getburl">
          <i class="mintui mintui-back"></i>
        </div>
        <h1 class="mint-header-title">{{$t('anypay_title')}}</h1>
        <div class="mint-header-button is-right">
          <i class="iconfont icon-menu1"
             @click="sheetVisible=true"
             slot="right"> </i>

        </div>
      </header>
    </div>
    <actionsheet :actions="actions"
                 v-model="sheetVisible"
                 :cancelText="$t('cancel')"></actionsheet>

    <div class="checkstand-main">
      <p class="des">{{$t('anypay_des')}}</p>
      <div class="screen clear">
        <span class="category "
              v-bind:class="{ active: listVisible }"
              @click='toggleList'>
          {{paySubListSelect.descript}}
          <i class="iconfont icon-xia"></i>
        </span>

        <div class="price-wrapper">
          <div class="price">{{price}}</div>
        </div>
      </div>

      <div class="category-list clear"
           v-if="listVisible">
        <div class="category-tabs">
          <ul>
            <li v-for="(item ,index) in payList"
                :key="'payList' + index"
                :name="item.code"
                v-bind:class="{ active: (item.code== payListActive) }"
                @click="changeFirstPayCode(index)"><span>{{item.descript}}</span></li>
          </ul>
        </div>
        <div class="category-content">
          <ul>
            <li v-for="(item ,index) in paySubList"
                :key="'paySubList' + index"
                :name="item.code"
                v-bind:class="{ active: (item.code== paySubListActive) }"
                @click="changeSubPayCode(index)"><span>{{item.descript}} </span></li>
          </ul>
        </div>
      </div>

      <div id="paykeyboard"
           class="keyboard"
           v-else>
        <div class="column">
          <ul class="clear">
            <li @click="keyDown('number','1')"><span>1</span></li>
            <li @click="keyDown('number','2')"><span>2</span></li>
            <li @click="keyDown('number','3')"><span>3</span></li>
            <li @click="keyDown('action','delete')"><span class="action">{{$t('anypay_backspace')}}</span></li>
          </ul>
        </div>
        <div class="column">
          <ul class="clear">
            <li @click="keyDown('number','4')"><span>4</span></li>
            <li @click="keyDown('number','5')"><span>5</span></li>
            <li @click="keyDown('number','6')"><span>6</span></li>
            <li @click="keyDown('action','reset')"><span class="action">{{$t('empty')}}</span></li>
          </ul>
        </div>
        <div class=" column2 clear">
          <div class="column2-left">
            <ul class="clear">
              <li @click="keyDown('number','7')"><span>7</span></li>
              <li @click="keyDown('number','8')"><span>8</span></li>
              <li @click="keyDown('number','9')"><span>9</span></li>

            </ul>
            <ul class="clear">
              <li @click="keyDown('number','00')"><span>00</span></li>
              <li @click="keyDown('number','0')"><span>0</span></li>
              <li @click="keyDown('number','.')"><span>.</span></li>

            </ul>
          </div>
          <div class="column2-right"
               @click="keyDown('action','submmit')">
            <div>
              <span class="qd">{{$t('determine')}}</span>
              <span class="scan">({{$t('anypay_alipay_wechat')}})</span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <mt-popup v-model="popupVisibleW"
              position="bottom"
              class="checkOutPop"
              :modal="true">
      <div class="mint-indicator">
        <div class="mint-indicator-wrapper"
             style="padding: 20px;">
          <span class="mint-indicator-spin">
            <div class="mint-spinner-snake"
                 style="border-top-color: rgb(204, 204, 204); border-left-color: rgb(204, 204, 204); border-bottom-color: rgb(204, 204, 204); height: 32px; width: 32px;"></div>
          </span> <span class="mint-indicator-text"
                        style="">{{$t('index_homeData_title')}}</span>
          <mt-button type="primary"
                     style="margin-top:20px"
                     size="small"
                     @click="closeQ">取消
          </mt-button>
        </div>
        <div class="mint-indicator-mask">
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import {Actionsheet, Popup} from "mint-ui";
  import {getPayWay} from "../../../assets/js/anypay";
  import FastClick from "fastclick";

  export default {
    data() {
      return {
        listVisible: false,
        payList: [],
        payListActive: "",
        payCode: "",
        paySubList: [],
        paySubListActive: "",
        paySubListSelect: {},
        orderId: "",
        orderNo: "",
        sheetVisible: false,
        price: "0",
        popupVisibleW: false,
        actions: [],
        rights: []
      };
    },
    mounted() {
      FastClick.attach(document.getElementById("paykeyboard"));
      this.init();
      var lPaySubListActive = localStorage.paySubListActive;
      if (lPaySubListActive != undefined) {
        this.payListActive = localStorage.payListActive;
        this.paySubList = JSON.parse(localStorage.paySubList);
        this.paySubListActive = localStorage.paySubListActive;
        this.paySubListSelect = JSON.parse(localStorage.paySubListSelect);
      }
      this.actions = [];
      this.actions.push({
        name: this.$t("anypay_action_search"),
        method: () => {
          this.$router.push("/anypay/Search");
        }
      });
      this.actions.push({
        name: this.$t("anypay_action_goRefund"),
        method: this.goRefund
      });
      this.actions.push({
        name: this.$t("anypay_action_reAccount"),
        method: this.reAccount
      });
    },
    methods: {
      getburl() {
        return this.$router.push(this.$route.query.redirect || '/');
      },
      goRefund() {
        if (this.rights.indexOf("wap!anypay!refund") < 0) {
          this.msg2(this.$t("msg_goRefund"));
          this.sheetVisible = false;
        } else {
          this.$router.push("/anypay/RefundList");
        }
      },
      toggleList() {
        this.listVisible = !this.listVisible;
      },
      getCategoryList() {
        this.$http.post("/mobilepmsapi/pay/getPayAccount").then(res => {
          if (res.data.result == 0) {
            var result = res.data.retVal;
            this.payList = result.pay;
            this.payCode = result.payCode;
            this.rights = result.rights;
            // 默认选中列表中的第一个内容
            var lPaySubListActive = localStorage.paySubListActive;
            if (lPaySubListActive == undefined) {
              if (JSON.stringify(this.payList[0]) != "{}") {
                this.paySubList = result.pay[0].list;
                this.payListActive = result.pay[0].code;
                if (JSON.stringify(this.payList[0].list) != "{}") {
                  this.paySubListActive = this.payList[0].list[0].code;
                  this.paySubListSelect = this.payList[0].list[0];
                }
              }
            }
          } else {
            this.msg2(res.data.msg);
          }
        });
      },
      changeFirstPayCode(index) {
        this.paySubList = this.payList[index].list;
        this.payListActive = this.payList[index].code;
        localStorage.setItem("payListActive", this.payListActive);
        localStorage.setItem("paySubList", JSON.stringify(this.paySubList));
      },
      changeSubPayCode(index) {
        this.paySubListActive = this.paySubList[index].code;
        this.paySubListSelect = this.paySubList[index];
        //将选项中的内容放到缓存里面
        localStorage.setItem("paySubListActive", this.paySubListActive);
        localStorage.setItem(
          "paySubListSelect",
          JSON.stringify(this.paySubListSelect)
        );
        localStorage.removeItem("anypayOrderId");
        this.listVisible = false;
      },
      reAccount() {
        if (localStorage.getItem("anypayOrderId") == null) {
          //无上次订单号记录，无法核对入账，如有异常请人工处理
          this.msg2(this.$t("msg_reAccount"));
        } else {
          this.sheetVisible = false;
          var transData = {
            sceneCode: "anypay",
            transType: "07",
            authCode: null,
            hotelOutId: localStorage.getItem("anypayOrderId")
          };
          this.$http.post("/mobilepmsapi/gcpay/pay", transData).then(res => {
            transData.transType = "05";
            transData.transMode = res.data.retVal.transMode;
            this.qtime = 1;
            this.popupVisibleW = true;
            this.processResult(res.data, transData);
          });
        }
      },
      payOrder() {
        var money = Number(this.price);
        if (money <= 0 || money > 100000) {
          this.msg2(this.$t("msg_payOrder"));
          return;
        }
        this.getbarcode();
      },
      initOrder() {
        var url = "/mobilepmsapi/pay/initOrder";
        if (
          localStorage.getItem("anypayOrderId") == null ||
          localStorage.getItem("anypayPrice") == null ||
          localStorage.getItem("anypayPrice") != this.price
        ) {
          var parameter = {
            accont: this.paySubListSelect.ext,
            feeCode: this.paySubListSelect.code,
            feeName: this.paySubListSelect.descript,
            totalMoney: this.price
          };
          this.$http.post(url, parameter).then(res => {
            if (res.data.result == 0) {
              this.orderId = res.data.retVal.id;
              this.orderNo = res.data.retVal.orderNo;
              localStorage.setItem("anypayOrderId", this.orderId);
              localStorage.setItem("anypayPrice", this.price);
              //调用支付接口
              this.payOrder();
            } else {
              this.msg2(res.data.msg);
            }
          });
        } else {
          this.orderId = localStorage.getItem("anypayOrderId");
          //console.log(this.orderId);
          this.payOrder();
        }
      },
      getbarcode() {
        var A = plus.webview.getLaunchWebview();
        var that = this;
        window.barback = function (a) {
          if (a.length < 18 || a.length > 19) {
            that.msg(this.$t("msg_getbarcode"));
            return;
          }
          that.startPay(a);
        };
        A.evalJS("getcardCode()");
      },
      startPay(authCode) {
        var transData = {
          sceneCode: "anypay",
          totalFee: Number(this.price),
          transType: "01",
          authCode: authCode,
          hotelOutId: this.orderNo,
          descript: this.$t("anypay_scene")
        };
        this.popupVisibleW = true;
        this.$http
          .post("/mobilepmsapi/gcpay/pay", transData, {nopost: true})
          .then(res => {
            transData.transType = "05";
            transData.transMode = res.data.retVal.transMode;
            this.qtime = 30;
            this.processResult(res.data, transData);
          });
      },
      processResult(data, transData) {
        if (data.result == 0) {
          if (data.retVal.status == "SUCCESS") {
            this.popupVisibleW = false;
            this.paySuccess(data.retVal);
          } else if (data.retVal.status == "FAIL") {
            this.popupVisibleW = false;
            this.error2(data.retVal.errorInfo);
          } else {
            if (this.qtime > 0) {
              var that = this;
              setTimeout(function () {
                that.Query(transData);
              }, 6000);
            } else if (this.qtime == 0) {
              this.popupVisibleW = false;
              this.error2(this.$t("anypay_overtime"));
            }
          }
        } else {
          this.msg2(data.msg);
        }
      },
      closeQ() {
        this.confirm2(this.$t("MessageBox_closeQ"), action => {
          this.popupVisibleW = false;
          this.qtime = -1;
        })
      },
      Query(qobj) {
        //console.log(this.qtime);
        this.$http
          .post("/mobilepmsapi/gcpay/pay", qobj, {nopost: true})
          .then(res => {
            if (res.data.result == 0) {
              this.qtime = this.qtime - 1;
              this.processResult(res.data, qobj);
            } else {
              this.error2(res.data.msg);
            }
          });
      },
      paySuccess(transData) {
        // console.log("sss");
        // console.log(this.orderId);
        var parameter = {
          id: this.orderId,
          payCode: this.payCode,
          payMoney: Number(transData.totalFee),
          taBody: JSON.stringify(transData),
          taNo: transData.gcsn.substring(8, 14) + "_" + transData.gcsn,
          taWay: getPayWay(transData),
          taOrderNo: transData.tradeNo
        };
        this.$http.post("/mobilepmsapi/pay/paySuccess", parameter).then(res => {
          if (res.data.result == 0) {
            localStorage.removeItem("anypayOrderId");
            localStorage.removeItem("anypayPrice");
            this.msg2(this.$t("msg_paySuccess"));

            this.price = 0;
          } else {
            this.error2(res.data.msg);
          }
        });
      },
      keyDown(type, value) {
        // 初次的情况
        if (this.price == "0") {
          if (type == "number") {
            if (value == ".") {
              this.price = this.price + value;
            } else if (value == "00") {
              this.price = "0";
            } else {
              this.price = value;
            }
          } else {
            if (value == "submmit") {
              //请输入支付金额
              this.msg2(this.$t("msg_keyDown"));
            }
          }
        } else {
          if (type == "number") {
            var strv = this.price + "";
            var dIndex = strv.indexOf(".");
            if (dIndex >= 0) {
              if (value == "." || value == "00") {
                return;
              }
              if (strv.length - dIndex > 2) {
                return;
              }
            }
            if (Number(this.price + value) > 1000000) {
              //超过最多允许金额
              this.msg2(this.$t("msg_than_price"));
              return;
            }
            this.price = this.price + value;
          } else {
            if (value == "delete") {
              var vLength = this.price.length;
              if (vLength == 1) {
                this.price = "0";
              } else {
                this.price = this.price.substring(0, vLength - 1);
              }
            }
            if (value == "reset") {
              this.price = "0";
            }
            if (value == "submmit") {
              this.initOrder();
            }
          }
        }
      },
      init() {
        this.getCategoryList();
      }
    },
    components: {
      actionsheet: Actionsheet
    }
  };
</script>
<style lang="less">
  .pay {
    height: 100%;
    position: relative;

    .checkOutPop {
      width: 100%;
      height: 100%;
      background: #3336;
    }

    .topHeader {
      height: 40px;

      .mintui-back {
        font-size: 0.64rem;
      }

      .icon-menu1 {
        font-size: 0.5rem;
        padding: 0.3rem 0.1rem;
      }
    }

    .topHeader .mint-header {
      color: #fff;
      font-size: 16px;
    }

    .checkstand-main {
      position: absolute;
      height: auto;
      top: 1rem;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 15px;

      .des {
        color: #333;
        font-size: 18px;
        padding: 15px 0;
      }

      .screen {
        width: 100%;
        border-radius: 5px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;
        margin-top: 0.3rem;
        background: #f1f1f1;
        padding: 15px;
        box-sizing: border-box;

        .category {
          display: inline-block;
          font-size: 16px;
          width: 3.5rem;
          color: #666;

          i {
            padding: 2px 0 0 0;
            font-size: 12px;
          }
        }

        .active {
          color: #d8af68;
        }

        .price-wrapper {
          flex: 1;
          text-align: right;
          border-radius: 5px;
        }

        .price {
          display: inline-block;
          font-size: 36px;
          color: #cc7837;
          font-weight: bold;
          text-align: right;
          border: none;
        }
      }

      .keyboard {
        position: absolute;
        height: auto;
        top: 5.5rem;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 0 0 0;
        overflow: hidden;

        .column {
          height: 25%;
          background: #fff;
          color: #999;

          ul {
            height: 100%;
            position: relative;
            border-top: 1px solid #d9d9d9;
          }
        }

        .column ul li {
          float: left;
          width: 25%;
          height: 100%;
          display: flex;
          border-right: 1px solid #d9d9d9;
          margin-right: -1px;
          justify-content: center; /*实现水平居中*/
          align-items: center; /*实现垂直居中*/

          &:active {
            background: #d9d9d9;
          }

          span {
            font-size: 26px;

            &.action {
              font-size: 18px;
              font-weight: normal;
            }
          }
        }

        .column2 {
          height: 50%;
          background: #fff;
          color: #999;

          .column2-left {
            display: inline-block;
            float: left;
            width: 75%;
            height: 100%;
          }

          .column2-left ul {
            height: 50%;
            border-top: 1px solid #d9d9d9;
          }

          .column2-left ul li {
            float: left;
            width: 33.33333333%;
            height: 100%;
            display: flex;
            border-right: 1px solid #d9d9d9;
            margin-right: -1px;
            justify-content: center;
            align-items: center;

            &:active {
              background: #d9d9d9;
            }

            span {
              font-size: 26px;
            }
          }

          .column2-right {
            float: right;
            width: 25%;
            background: #cc7837;
            color: #fff;
            border-top: 1px solid #cc7837;
            border-bottom: 2px solid #cc7837;
            box-sizing: border-box;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            &:active {
              background: #b76b2f;
            }

          }

          .column2-right div {
            span {
              display: block;
            }

            .qd {
              font-size: 18px;
              text-align: center;
              padding-bottom: 0.2rem;
            }

            .scan {
              font-size: 10px;
            }
          }
        }
      }

      .category-list {
        position: absolute;
        height: auto;
        top: 5.5rem;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 8px 10px 8px;
        padding: 13px 0;
        background: #ffffff;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        .category-tabs {
          width: 33.33%;
          float: left;
          display: inline-block;
          height: 100%;
          border-right: 1px solid #eeeeee;
        }

        .category-tabs ul {
          height: 100%;
          overflow: auto;
        }

        .category-tabs ul li {
          height: 14.28%;
          padding-left: 0.3rem;
          position: relative;
          vertical-align: middle;
        }

        .category-tabs ul li.active {
          background: #d8af68;
          color: #fff;
        }

        .category-tabs ul li.active span {
          color: #fff;
        }

        .category-tabs ul li span {
          width: 100%;
          height: 100%;
          font-size: 14px;
          color: #999999;
          display: flex;
          align-items: center;
        }

        .category-content {
          width: 66%;
          float: right;
          display: inline-block;
          height: 100%;
        }

        .category-content ul {
          height: 100%;
          padding-left: 15px;
          overflow: auto;
        }

        .category-content ul li {
          height: 14.28%;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #d9d9d9;
          padding: 0 15px;
          font-size: 14px;
          color: #666;
          &:active{
            background: #d9d9d9;
          }
        }

        .category-content ul li.active span {
          color: #d8af68;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pay.vue?15d6901e